import { builtinV1 } from '../../builtin'

// klinecharts 9.8.12 built-in 'PSY' (dist/index.esm.js), untouched: version 1 for existing instances only.
export default builtinV1({ id: 'PSY', label: 'Psychological Line', pane: 'sub', params: [12, 6], outputs: ['psy', 'maPsy'] })
